import { createContext } from 'react';

const OrderInvitationContext = createContext(null);

export { OrderInvitationContext };
